import { Injectable } from '@angular/core';

import { CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class AccaBoostBetslipTypeStateValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override readonly type = CriteriaType.MultiSingleBet;

    constructor() {
        super();
    }

    isValid(_: IRewardToken, { selectedPicks }: TokenValidationInput): boolean {
        return selectedPicks.length > 0;
    }
}
